import type { GuideContent, GuideCreate, GuideUpdate } from "@/types";
import { apiClient } from "./client";

export const guideService = {
  list: async (propertyId: string): Promise<GuideContent[]> => {
    const { data } = await apiClient.get<GuideContent[]>("/admin/guides", {
      params: { property_id: propertyId },
    });
    return data;
  },

  create: async (propertyId: string, body: GuideCreate): Promise<GuideContent> => {
    const { data } = await apiClient.post<GuideContent>("/admin/guides", {
      ...body,
      property_id: propertyId,
    });
    return data;
  },

  update: async (id: string, body: GuideUpdate): Promise<GuideContent> => {
    const { data } = await apiClient.patch<GuideContent>(`/admin/guides/${id}`, body);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/guides/${id}`);
  },

  /** 표준 안내 9종을 미게시 초안으로 깔아 준다. 제목이 같은 항목은 건너뛴다. */
  seed: async (propertyId: string): Promise<{ created: number }> => {
    const { data } = await apiClient.post<{ created: number }>("/admin/guides/seed", null, {
      params: { property_id: propertyId },
    });
    return data;
  },
};
